import React, { useState } from 'react'
import ReactInfiniteScroller from 'react-infinite-scroller'

import ArticleList from '@src/components/ArticleList'
import { Article } from '@models/Article'

import * as style from './style.module.sass'

type InfiniteScrollProps = {
  articles: Article[]
  gtmClickType: string
  gtmLabel?: string
  displaysCategoryInArticleList?: boolean
}

const InfiniteScroll: React.FC<InfiniteScrollProps> = ({
  articles,
  gtmClickType,
  gtmLabel,
  displaysCategoryInArticleList,
}) => {
  const itemsPerPage = 12
  const [hasMoreItems, sethasMoreItems] = useState(true)
  const [records, setrecords] = useState(itemsPerPage)
  const loadMore = () => {
    if (records >= articles.length) {
      sethasMoreItems(false)
    } else {
      setTimeout(() => {
        setrecords(records + itemsPerPage)
      }, 1000)
    }
  }

  const showItems = () => {
    const items = []
    for (let i = 0; i < records; i++) {
      // TODO: undefinedのことがあるのか確認
      if (articles[i] !== undefined) {
        items.push(articles[i])
      }
    }

    return (
      <ArticleList
        articles={items}
        gtmClickType={gtmClickType}
        gtmLabel={gtmLabel}
        displaysCategory={displaysCategoryInArticleList}
      />
    )
  }

  return (
    <ReactInfiniteScroller
      loadMore={loadMore}
      hasMore={hasMoreItems}
      loader={<p key={0} />}
      useWindow={true}
      className={style.loadArea}
    >
      {showItems()}
    </ReactInfiniteScroller>
  )
}

export default InfiniteScroll
